module.exports = __webpack_public_path__ + "img/1-4-2023_bambu_thumb.a247a248.jpeg";